<div id="sectionElement" class="m-0-auto animatable reveal">
  <div class="section-info">
    <div class="flex-between-center">
      <h2 class="section-title">Our Works</h2>
      <button mat-button class="view-all" (click)="navigateToPortfolio()">
        View all
        <mat-icon>arrow_right_alt</mat-icon>
      </button>
    </div>
    <div class="flex-between">
      <p class="section-description">
        Explore some of our works to see how we turn ideas into practical, high-quality digital solutions.
      </p>
      <div class="carousel-buttons">
        <!-- We're calling `handleClick` with a direction argument when the buttons are clicked -->
        <button (click)="handleClick('previous')" class="button button--previous" type="button">
          <mat-icon>keyboard_arrow_left</mat-icon>
        </button>
        <button (click)="handleClick('next')" class="button button--next" type="button">
          <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>


<div class="list-wrapper">
  <ul class="list" #list>
    @for (p of works(); track p.id) {
      <li drag-scroll-item (click)="navigateToCase(p.documentId!)">
        <app-portfolio-card [project]="p"></app-portfolio-card>
      </li>
    }
  </ul>
</div>
